export const SKILL_LEVELS = [
    { level: 1 as const, name: 'Junior', color: 'var(--color-skill-junior)' },
    { level: 2 as const, name: 'Mid-Level', color: 'var(--color-skill-intermediate)' },
    { level: 3 as const, name: 'Senior', color: 'var(--color-skill-senior)' },
    { level: 4 as const, name: 'Expert', color: 'var(--color-skill-principal)' },
];

export const getSkillLevelInfo = (level: 1 | 2 | 3 | 4) => {
    return SKILL_LEVELS.find((sl) => sl.level === level) || SKILL_LEVELS[0];
};

export const getTextColor = (level: number) => {
    return level >= 3 ? 'white' : 'text.primary';
};
